export default "__VITE_ASSET__o$WLcmQk__"